import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";

/// `BUILD_TAG` keeps the bundle's content hash fresh on each
/// manually-tagged release so Cloudflare Pages allocates a new
/// storage record instead of serving the previous (occasionally
/// corrupted) blob. Logged once so it survives Vite tree-shaking,
/// and visible in DevTools for support cases too. Bump on any
/// release where we need a forced cache-bust.
const BUILD_TAG = "v1.3.0-build-55";
console.info("nav-games", BUILD_TAG);

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root element");
createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
